import {Controller} from "@hotwired/stimulus";
import * as moment from "moment/moment";
import $ from "jquery";
import {useModal} from "../../js/stimulus_use/use-modal";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'litigant--choose-or-create',
        'document--create-modal'
    ];

    static values = {
        litigantId: Number,
        litigantName: String,
        source: String,
        isViewed: Boolean,
        isGuideShown: Boolean,
        amount: Number,
        fees: Number,
        total: Number,
    };

    static targets = [
        'litigantName',
        'guide',
        'icon',
        'dontShowInput',
        'litigant',
        'form',
        'messageInput',
        'bookingDescriptionInput',
        'bookingDateInput',
        'bookingDateStartInput',
        'bookingDateEndInput',
        'bookingMediumInput',
        'bookingMediumGuide',
        'messageFileAttachmentInput',
        'fileAttachmentNames',
    ];

    dontShowAgainUrl = routes['app_booking_createnewunpaidbookingpopupdontshow'];
    viewedUrl = routes['app_booking_createnewunpaidbookingpopupviewed'];

    connect() {
        useModal(this, {
            withGuide: true,
            withViewed: true,
            withLitigant: true,
        });
    }

    onOpen() {
        if (this.litigantIdValue) {
            this.hideLitigant();
            this.showForm();
        } else if (!this.litigantIdValue) {
            this.hideForm();
            this.showLitigant();
        }
    }

    onHide() {
        this.hideForm();
        this.hideLitigant();

        this.clearForm();
    }

    onGuideShown() {
        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Chat",
                "action": "Source-" + this.sourceValue + " Unpaid Booking Invite | Promo Popup",
                "label": GA_EVENT_LABEL,
            },
        });
    }

    onLitigantShown() {
        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Chat",
                "action": "Source-" + this.sourceValue + " Unpaid Booking Invite | Litigant",
                "label": GA_EVENT_LABEL,
            },
        });
    }

    showLitigantOrForm() {
        if (this.litigantIdValue) {
            this.showForm();
        } else {
            this.showLitigant();
        }
    }

    litigantChosenOrCreated() {
        this.hideLitigant();
        this.showForm();
    }

    showForm() {
        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Chat",
                "action": "Source-" + this.sourceValue + " Unpaid Booking Invite | Form",
                "label": GA_EVENT_LABEL,
            },
        });

        if (this.litigantChooseOrCreateOutlet.getName() !== null) {
            $(this.litigantNameTarget).text(this.litigantChooseOrCreateOutlet.getName());
        } else {
            $(this.litigantNameTarget).text(this.litigantNameValue);
        }

        this.formTarget.style.removeProperty('display');
    }

    hideForm(event) {
        event && event.preventDefault();

        this.formTarget.style.setProperty('display', 'none');
    }

    clearForm(event) {
        event && event.preventDefault();

        this.clearFormErrors();

        this.bookingDescriptionInputTarget.value = '';
        this.messageInputTarget.value = '';
        $(this.messageFileAttachmentInputTarget).removeProp('files');
        $(this.fileAttachmentNamesTarget).text('')

        this.litigantChooseOrCreateOutlet.clear();
    }

    clearFormErrors() {
        this.litigantChooseOrCreateOutlet.clearErrors();

        this.formTarget.querySelectorAll('.is-invalid').forEach((element) => {
            element.classList.remove('is-invalid');
        });
    }

    submitForm(event) {
        event && event.preventDefault();

        let hasErrors = false;

        if (!this.bookingDescriptionInputTarget.value) {
            this.bookingDescriptionInputTarget.classList.add('is-invalid');
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        showPreloader();

        const formData = new FormData();

        formData.append('message', this.messageInputTarget.value);
        formData.append('description', this.bookingDescriptionInputTarget.value);
        formData.append('date', moment(this.bookingDateInputTarget.value, 'DD/MM/YYYY').format('YYYY-MM-DD'));
        formData.append('start', this.bookingDateStartInputTarget.value);
        formData.append('end', this.bookingDateEndInputTarget.value);
        formData.append('medium', this.bookingMediumInputTarget.value);
        formData.append('source', this.sourceValue);
        // The input is multiple, so append every picked file.
        Array.from(this.messageFileAttachmentInputTarget.files).forEach(file => {
            formData.append('document[]', file);
        });

        if (this.litigantIdValue) {
            formData.append('litigant_id', this.litigantIdValue)
        } else {
            const litigantData = this.litigantChooseOrCreateOutlet.getData();
            // foreach property of litigant data add to form data
            for (const [key, value] of Object.entries(litigantData)) {
                formData.append(key, value);
            }
        }

        $.ajax({
            url: routes['app_booking_createnewbooking'],
            data: formData,
            type: 'post',
            contentType: false,
            processData: false,
            success: (response) => {
                if (!response.status) {
                    hidePreloader();
                    addAlert('danger', response.message || translations['profile.An unknown error occurred.']);
                    return;
                }

                dataLayer.push({
                    "event": "dataLayer.gaEvent",
                    "gaEvent": {
                        "category": "Chat",
                        "action": "Source-" + this.sourceValue + " Unpaid Booking Invite | Complete",
                        "label": GA_EVENT_LABEL,
                    },
                });

                if (window.location.href === response.chat_url) {
                    location.reload()
                } else {
                    window.location.href = response.chat_url;
                }
            }
        }).fail(() => {
            hidePreloader();
            addAlert('danger', translations['profile.An unknown error occurred.']);
        });
    }

    mediumChange() {
        if ('office' === this.bookingMediumInputTarget.value) {
            $(this.bookingMediumGuideTarget).html(translations['booking_invite.Appointment by office']);
        } else if ('video' === this.bookingMediumInputTarget.value) {
            $(this.bookingMediumGuideTarget).html(translations['booking_invite.Appointment by video']);
        } else if ('phone' === this.bookingMediumInputTarget.value) {
            $(this.bookingMediumGuideTarget).html(translations['booking_invite.Appointment by phone']);
        }
    }

    fileAttachmentFieldChange() {
        let data = $(this.messageFileAttachmentInputTarget).prop('files');
        let filesTab = $(this.fileAttachmentNamesTarget)
        let fileNames = '';

        for (let i = 0; i < data.length; i++) {
            if (0 !== i) {
                fileNames += ", "
            }
            fileNames += (data[i].name + " ")
        }

        filesTab.text(fileNames);
    }
}